import { gql } from 'graphql-tag';

export const getStandardsMetadata = gql`
    query getStandardsMetadata(
        $itemId: String
        $itemVersion: String
        $languageLocale: String!
        $skillCodes: [String!]!
        $assignmentId: String
        $classId: String!
        $rootProgramId: String
    ) {
        getStandardsMetadata(
            assignmentId: $assignmentId
            classId: $classId
            itemId: $itemId
            itemVersion: $itemVersion
            languageLocale: $languageLocale
            skillCodes: $skillCodes
            rootProgramId: $rootProgramId
        ) {
            skillCode
            skillDescription
            standards {
                standardCode
                standardDescription
                standardFullPath
                standardGuid
            }
        }
    }
`;
